/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * DatePicker body for date selection by date
 *
 * @author Yakov Gushchin
 * @version 1.10.0
 * @since 1.10.0
 */

import { Moment } from 'moment';

import { EFormatData } from '../../../../../pages/PageDashboard/types/widgetTypes';
import useDatePickerBodyByDay from '../../hooks/Body/useDatePickerBodyByDay';
import { DatePickerBodyCellStyled } from '../../styled/Body/DatePickerBodyStyled';
import { DatePickerCellWrapperStyled } from '../../styled/DatePickerStyled';
import { IDatePickerBodyCellProps, IDatePickerBodyProps } from '../../types/datePickerTypes';


const DatePickerBodyByDay = (props: IDatePickerBodyProps) => {

    const {
        onSelectDateHandler,
    } = props;

    /*
    * -------------------------------------------
    *       Hooks: Component logic
    * -------------------------------------------
    */

    const {
        renderCells,
    } = useDatePickerBodyByDay(props)

    /*
    * -------------------------------------------
    *               Handlers
    * -------------------------------------------
    */

    const cellClickHandler = (day: Moment) => {
        onSelectDateHandler(day);
    }

    /*
    * -------------------------------------------
    *           Render component
    * -------------------------------------------
    */

    return (
        <DatePickerCellWrapperStyled>
            {
                renderCells().map((props: IDatePickerBodyCellProps) =>
                    <DatePickerBodyCellStyled
                        className={props.className}
                        key={props.key}
                        onClick={() => cellClickHandler(props.day)}
                    >
                        { props.day.format(EFormatData.OnlyDay) }
                    </DatePickerBodyCellStyled>,
                )
            }
        </DatePickerCellWrapperStyled>
    );
};

export default DatePickerBodyByDay;
